var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMore = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 40 40"
}, props), /*#__PURE__*/React.createElement("mask", {
  id: "more_svg__a",
  width: 40,
  height: 40,
  x: 0,
  y: 0,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "alpha"
  }
}, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M0 0h40v40H0z"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#more_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M9.107 22.444c-.673 0-1.248-.24-1.725-.719a2.364 2.364 0 0 1-.715-1.729c0-.673.24-1.248.719-1.725a2.364 2.364 0 0 1 1.729-.715c.673 0 1.248.24 1.725.719.477.48.716 1.056.716 1.729s-.24 1.248-.72 1.725a2.364 2.364 0 0 1-1.729.715Zm10.89 0c-.674 0-1.25-.24-1.726-.719a2.364 2.364 0 0 1-.715-1.729c0-.673.24-1.248.719-1.725a2.364 2.364 0 0 1 1.729-.715c.673 0 1.248.24 1.725.719.477.48.715 1.056.715 1.729s-.24 1.248-.719 1.725a2.364 2.364 0 0 1-1.729.715Zm10.888 0c-.673 0-1.248-.24-1.725-.719a2.364 2.364 0 0 1-.715-1.729c0-.673.24-1.248.719-1.725a2.364 2.364 0 0 1 1.729-.715c.673 0 1.248.24 1.725.719.477.48.715 1.056.715 1.729s-.24 1.248-.719 1.725a2.364 2.364 0 0 1-1.729.715Z"
}))));
export default SvgMore;